import { IntlShape } from 'react-intl';

import { IModifierSelections } from 'components/product-detail-v2/modifier/types';
import { ModifierTypes, SingleOrMultipleModifierSelection } from 'state/product-wizard-v2/types';

interface IGetProductItemCtaBtnProps {
  disabled: boolean;
  label: string;
}

interface IGetProductItemCtaBtnPropsParams {
  isEdit?: boolean;
  selections: IModifierSelections;
  singleOrMultipleModifierSelection: SingleOrMultipleModifierSelection | null;
  slotKeyToCustomize: string;
  formatMessage: IntlShape['formatMessage'];
}

export const getProductComboCtaBtnProps = ({
  selections,
  singleOrMultipleModifierSelection,
  slotKeyToCustomize,
  formatMessage,
}: IGetProductItemCtaBtnPropsParams): IGetProductItemCtaBtnProps => {
  const modifierSelection = singleOrMultipleModifierSelection?.[slotKeyToCustomize];
  const modifierType = modifierSelection?.type;

  let disabled = false;
  let label = formatMessage({ id: 'updateItem' });

  const totalQuantitySelected = Object.values(selections ?? {}).reduce(
    (sum, item) => sum + item.quantity,
    0
  );

  const totalQuantityLessThanMaxAmount =
    totalQuantitySelected < (modifierSelection?.maxAmount || 0);

  if (
    !!modifierSelection &&
    modifierSelection.type === ModifierTypes.MULTIPLE_CHOICE &&
    totalQuantityLessThanMaxAmount
  ) {
    const remainingSelections = (modifierSelection?.maxAmount || 0) - totalQuantitySelected;

    if (remainingSelections && remainingSelections !== modifierSelection?.maxAmount) {
      disabled = true;
      label =
        modifierType === ModifierTypes.MULTIPLE_CHOICE
          ? formatMessage(
              {
                id: 'selectRemaining',
              },
              { amount: remainingSelections }
            )
          : formatMessage(
              {
                id: 'selectSingleChoice',
              },
              {
                amount: remainingSelections,
                itemName: modifierSelection?.name,
              }
            );
    }
  }

  return { disabled, label };
};
